import {mapGetters} from "vuex";

export default {
    name: "btnCloseNotBorder",
    methods:{
        changeVision(){
            this.$store.dispatch('changeVision')
        }
    },
    computed: mapGetters(['toggleSidebar'])
}
